<template>
  <el-dialog
          style="margin-top: -50px;"
          title="选择岗位"
          :close-on-click-modal="false"
          width="80%"
          :visible.sync="visible">
    <div style="text-align: center;">
      <el-transfer
              class="wf-position-bind"
              style="text-align: left;display: inline-block"
              :titles="titles"
              filterable
              filter-placeholder=""
              v-model="selectIds"
              :data="dataList">
      </el-transfer>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取消
      </el-button>
      <el-button size="small" type="primary" @click="dataFormSubmit()">确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { fetchPositionForUser } from '@/controller/sys'
  import { setUserTask, listBindIds } from '@/controller/workflow'
  export default {
    data () {
      return {
        titles: ['岗位列表', '已关联'],
        dataForm: {
          id: '',
          key: ''
        },
        nodeName: '',
        dataList: [],
        selectIds: [],
        visible: false
      }
    },
    methods: {
      init(key, name) {
        this.dataForm.key = key || ''
        this.dataList = []
        this.selectIds = []
        this.nodeName = name
        this.visible = true
        fetchPositionForUser({},sessionStorage.getItem('mainBodyId')).then(data => {
          if (data && data.code === '00') {
            data.body.forEach((item, idx) => {
              this.dataList.push({
                label: item.positionName,
                key: item.id,
                index: idx
              })
            })
            listBindIds({processDefKey: this.dataForm.key, nodeName: this.nodeName}).then(data => {
              if (data.body && data.code === '00') {
                this.selectIds = data.body
              } else {
                this.selectIds = []
              }
              this.dataListLoading = false
            })
          } else {
            this.dataList = []
          }
          this.dataListLoading = false
        })
      },
      dataFormSubmit() {
        setUserTask(
                {
                  'id': this.dataForm.id || undefined,
                  'ids': this.selectIds,
                  'processDefinitionKey': this.dataForm.key,
                  'userTaskName': this.nodeName
                }
        ).then(data => {
          if (data && data.code === '00') {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          }
        }).catch(error => {
          console.log(error)
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .wf-position-bind.el-transfer{
    /deep/ .el-transfer-panel{
      width: 350px;
      height: 450px;
      .el-transfer-panel__list.is-filterable{
        height: 350px;
      }
    }
  }
</style>
